import { useTranslation } from "react-i18next";

import { SectionHeader } from "@pentabd/ui";

import { AddDossier, DossierTable } from "./components";

import { useDossier } from "@hooks/HRM/employee/useDossier";
import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

export interface AprPropsType {
  id: number | null;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  isProfileDisabled: boolean;
}

const DOSSIER = ({
  id,
  setIsErrorModalOpen,
  setIsSuccessModalOpen,
  isProfileDisabled,
}: AprPropsType) => {
  const { t } = useTranslation();

  const data = useDossier(id as number);

  const { user } = useUser();
  const { employeeMasterId, realm_roles: roles } = user || {};

  return (
    <>
      <div className="pt-10">
        <SectionHeader title={t("EMPLOYEE.DOSSIER_INFO.HEADING")} />
      </div>
      <DossierTable
        data={data}
        setIsErrorModalOpen={setIsErrorModalOpen}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
      />
      {(getAccess(roles, "DOSSIER_UPDATE") ||
        Number(employeeMasterId) === Number(id)) &&
        !isProfileDisabled && (
          <AddDossier
            id={id as number}
            data={data}
            setIsErrorModalOpen={setIsErrorModalOpen}
            setIsSuccessModalOpen={setIsSuccessModalOpen}
          />
        )}
    </>
  );
};

export default DOSSIER;
